import { BRANDS, determineBrandFromURL } from "../../helpers/brand";
import { breakpoints } from "../../helpers/breakpoints";

export const accountHeader = () => {
  const brand = determineBrandFromURL();

  if (brand === BRANDS.STAYCITY) {
    const header = document.querySelector(".my-account-section-header--sc");
    const headerHtml = header?.querySelector(".t-h0");

    if (
      headerHtml &&
      header &&
      header.textContent &&
      window.innerWidth < breakpoints.screen1024
    ) {
      headerHtml.innerHTML = header.textContent
        .trim()
        .split(" ")
        .join("<br />");
    }
  }
};
